import { StringProps } from "./lib/type";
import { uaStrings } from "./uaStrings";

const setLanguage = () => {
    return uaStrings
};


export const strings: StringProps = setLanguage();